module.exports = __webpack_public_path__ + "img/cantdelimar-logo.354c4705.png";